import Link from "next/link";

interface SignupTermsNoticeProps {
  className?: string;
  linkClassName?: string;
}

/**
 * The agreement a sign-in button accepts. Render it beside every control that
 * calls `setTermsAcceptanceIntent(true)`, which records the acceptance.
 */
export function SignupTermsNotice({
  className,
  linkClassName,
}: SignupTermsNoticeProps) {
  return (
    <p className={className}>
      By continuing, you agree to our{" "}
      <Link
        href="/legal/terms-of-service"
        target="_blank"
        className={linkClassName}
      >
        Terms
      </Link>{" "}
      &{" "}
      <Link
        href="/legal/privacy-policy"
        target="_blank"
        className={linkClassName}
      >
        Privacy
      </Link>
      .
    </p>
  );
}
